/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { Component } from "react";
import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import styled from "styled-components";
import PropTypes from "prop-types";
import LoadingIndicator from "../../components/LoadingIndicator";
import EmptyHistory from "../../components/EmptyHistory";
import PointHistoryListing from "../../components/PointHistoryListing";
import * as selectors from "../../selectors";
import * as pointAction from "../../actions/point";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`;

class PointHistoryPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
    this.fetchPointTransactionListData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchPointTransactionListData();
      }
    }
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="point.transaction.title"
        defaultMessage="Point Transaction"
        description="Point Transaction Title"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed());
    showNavbar(true);
    showTabbar(false);
  };

  fetchPointTransactionListData = (pageNumber = 1, hideLoading = false) => {
    const { getPointTransactionListDataRequest, authToken } = this.props;

    if (authToken) {
      getPointTransactionListDataRequest(pageNumber, hideLoading);
    }
  };

  getLoadingIndicator = () => {
    const { hideLoading, loading } = this.props;

    if (hideLoading) {
      return null;
    }

    if (!loading) {
      return null;
    }

    return <LoadingIndicator />;
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onEndReached = () => {
    const { pointTransactionPagination } = this.props;

    if (pointTransactionPagination) {
      const { pageCount, currentPage } = pointTransactionPagination;

      if (currentPage < pageCount) {
        this.fetchPointTransactionListData(currentPage + 1, true);
      }
    }
  };

  render() {
    const { animationClass } = this.state;
    const { loading, pointTransactionData } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        {pointTransactionData && pointTransactionData.length > 0 ? (
          <PointHistoryListing
            {...this.props}
            items={pointTransactionData}
            onEndReached={this.onEndReached}
            showFooterLoading={
              loading && pointTransactionData && pointTransactionData.length > 0
            }
          />
        ) : (
          <EmptyHistory {...this.props} />
        )}
      </StyledContainer>
    );
  }
}

PointHistoryPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  loading: PropTypes.bool,
  hideLoading: PropTypes.bool,
  pointTransactionData: PropTypes.array,
  pointTransactionPagination: PropTypes.object,
  getPointTransactionListDataRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    loading: selectors.getPointTransactionListLoading(state),
    hideLoading: selectors.getPointTransactionListHideLoading(state),
    pointTransactionData: selectors.getPointTransactionListData(state),
    pointTransactionPagination: selectors.getPointTransactionListPagination(
      state
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPointTransactionListDataRequest: (pageNumber, hideLoading = false) =>
      dispatch(
        pointAction.getPointTransactionListRequest(pageNumber, hideLoading)
      )
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PointHistoryPage)
);



// WEBPACK FOOTER //
// ./src/containers/PointHistoryPage/index.js